import guestAxios from "@/utils/guestAxios";

export const guestFoodOrderApi = {
  getCategories: () => {
    return guestAxios.get("/api/guest-portal/food/categories");
  },

  getCategoryById: (categoryId) => {
    return guestAxios.get(`/api/Category/${categoryId}`);
  },

  getMenusByCategory: ({
    categoryId,
    search = "",
    pageNumber = 1,
    pageSize = 100,
    isAscending = true,
    sortBy = "",
  }) => {
    return guestAxios.get("/api/guest-portal/food/menus", {
      params: {
        search,
        pageNumber,
        pageSize,
        isAscending,
        categoryId,
        sortBy,
      },
    });
  },

  getExtras: () => {
    return guestAxios.get("/api/guest-portal/food/extras");
  },

  createOrder: (payload) => {
    return guestAxios.post("/api/Order/guest", payload);
  },

  getMyOrders: (params = {}) => {
    return guestAxios.get("/api/Order/guest", { params });
  },
};
